@let canReadWorkflow = userContext.canReadWorkflow();
@let canCreateWorkflow = userContext.canCreateWorkflow();

<div class="workflow-list-page">
  <topo-data-table-server
    #table
    [isActive]="isTableActive"
    [datasource]="datasource"
    [columns]="columDefs"
    [showHeader]="false"
    [headerLabel]="'MANAGEMENT.WORKFLOW.WORKFLOW-TEMPLATES' | translate"
    [newLabel]="'MANAGEMENT.WORKFLOW.NEW-WORKFLOW-TEMPLATE' | translate"
    [headerIcon]="'assets/images/purple_workflow.svg'"
    [showNewButton]="canCreateWorkflow"
    [showHeader]="true"
    [showSearch]="canReadWorkflow"
    [showMenu]="false"
    [showRowGroups]="false"
    [showSystemFields]="true"
    [enableInfiniteScroll]="true"
    [enableServerSort]="false"
    (paginate)="onPaginate($event)"
    (newClick)="newWorkflow()"
    (takeChanged)="onTakeChanged($event)"
    (storeUpdatedCalled)="onGridDataLoaded()"
    [skip]="skip"
    [take]="take"
  [totalCount]="totalCount"></topo-data-table-server>
</div>
<div
  class="template-type"
  fxLayout="row"
  fxLayoutAlign="center center">
  <div class="type-header">{{ 'MANAGEMENT.WORKFLOW.COLUMNS.TYPE' | translate }}</div>
  <div class="select is-small is-fullwidth">
    <select
      [(ngModel)]="selectedParentType"
      (change)="parentTypeChanged($event)">
      @for (type of parentTypes; track type.value) {
        <option
          [ngValue]="type.value">
          {{ type.name }}
        </option>
      }
    </select>
  </div>
</div>
<topo-confirm-delete
  [isActive]="!!workflowToDelete"
(confirmResponse)="confirmDeleteWorkflow($event)"></topo-confirm-delete>

<topo-workflow-edit (changed)="refreshGrid()"></topo-workflow-edit>
